import { AuthProvider } from 'src/providers/AuthProvider';

export default function AuthLayout({ children }) {
  return <AuthProvider>{children}</AuthProvider>;
}
